/**
 * @file AdvisorPage.js
 * @module src/js/pages/AdvisorPage
 * @description
 * **Page component for displaying advisor information.**
 * - Renders the `<Advisor />` component to show details about advisors.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import Advisor from "../components/Advisor";

export default function AdvisorPage() {
    return <Advisor />;
}
